/**
 * Tasks — the main task management hub.
 * Currently contains Deliveries. Additional task types can be added as tabs later.
 */
import { useState } from 'react'
import Deliveries from './Deliveries'
import './Tasks.css'

type Tab = 'deliveries'

export default function Tasks() {
  const [activeTab, setActiveTab] = useState<Tab>('deliveries')

  return (
    <div className="tasks-page">
      <div className="tasks-tabs">
        <button
          className={`tasks-tab ${activeTab === 'deliveries' ? 'active' : ''}`}
          onClick={() => setActiveTab('deliveries')}
        >
          📦 Deliveries
        </button>
        {/* Future tabs: Inspections, Surveys, Spraying, etc. */}
      </div>
      <div className="tasks-content">
        {activeTab === 'deliveries' && <Deliveries />}
      </div>
    </div>
  )
}
